module.exports = __webpack_public_path__ + "img/diagram-icon.c866e463.svg";